import { render, staticRenderFns } from "./xuqiuDetailReadonly.vue?vue&type=template&id=44e59cbc&scoped=true"
import script from "./xuqiuDetailReadonly.vue?vue&type=script&lang=js"
export * from "./xuqiuDetailReadonly.vue?vue&type=script&lang=js"
import style0 from "./xuqiuDetailReadonly.vue?vue&type=style&index=0&id=44e59cbc&prod&scoped=true&lang=css"
import style1 from "./xuqiuDetailReadonly.vue?vue&type=style&index=1&id=44e59cbc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44e59cbc",
  null
  
)

export default component.exports